import { queryOptions, skipToken } from '@tanstack/react-query';

import { getProps } from './api';

export const sessionQueries = {
  all: (pharmacyId: string | undefined) => ['props', pharmacyId] as const,
  detail: (pharmacyId: string | undefined) =>
    queryOptions({
      queryKey: sessionQueries.all(pharmacyId),
      queryFn: pharmacyId ? () => getProps(pharmacyId) : skipToken,
    }),
};
